export default {
  translation: {
    lng: 'বাংলা',
    name: 'নাম',
    email: 'ইমেইল',
    mobile: 'ফোন',
    password: 'পাসওয়ার্ড',
    confirm_password: 'কনফার্ম পাসওয়ার্ড',
    yes: 'হ্যা',
    no: 'না',
    login: 'লগইন',
    sign_in: 'সাইন ইন',
    enter_login_credential: 'আপনার ইমেইল এবং পাসওয়ার্ড দিন',
    register: 'রেজিস্টার',
    enter_registration_credential: 'রেজিস্ট্রেশান এর জন্য তথ্য দিন',
    forgot_pass: 'পাসওয়ার্ড উদ্ধার',
    back_to_login: 'লগইন এ ফিরে যান',
    enter_pin: 'মেসেজ এ প্রাপ্ত পিন প্রবেশ করুন।',
    please: 'অনুগ্রহপূর্বক',
    verify: 'যাচাই',
    send: 'পাঠান',
    again: 'আবার',
    send_again: 'আবার পাঠান',
    no_code_received: 'কোন পিন পাননি?',
    expense: 'খরচ',
  }
}
